<button class="btn btn-primary custom-button"
        [ngClass]="{'disabled': actionStatus === ActionStatus.DISABLED, 'readOnly':actionStatus === ActionStatus.READONLY}"
        [disabled]="actionStatus === ActionStatus.DISABLED"
        appTooltip="{{('BASKET.my' + nexiaBasketObjectKey) | translate}} ({{nexiaBasketObjects.length}})"
        [display]="screenWidth <= 1350"
        (click)="navigate()">
  <span class="icon icon-insert_drive_file"></span>
  <ng-container *ngIf="screenWidth > 1350">
    <span class="button-text">{{'BASKET.my' + nexiaBasketObjectKey | translate}}</span>
    <span class="button-objectsNb">{{nexiaBasketObjects.length}}</span>
  </ng-container>
</button>
